import { render } from "./RoomIndex.vue?vue&type=template&id=dc03f254"
import script from "./RoomIndex.vue?vue&type=script&lang=js"
export * from "./RoomIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__